import Network from '@/services/network'

export default function handleCompliance() {
    const network = new Network;
    
    // ********************* Tds-Vds-Register-start *****************
    const fetchTdsVdsRegister = (query) => {
        return network.api('get', '/compliance/tds-vds/register-list' + query);
    }
    const fetchTdsVdsRegisterClientWise = (query) => {
        return network.api('get', '/compliance/tds-vds/register-list-client' + query);
    }
    const fetchTdsVdsRegisterByBill = (query) => {
        return network.api('get', '/compliance/tds-vds/register-list-bill' + query);
    }
    const fetchVdsCertificateList = (query) => {
        return network.api('get', '/compliance/tds-vds/vds-certificate-list' + query);
    }
    const fetchTdsCertificateList = (query) => {
        return network.api('get', '/compliance/tds-vds/tds-certificate-list' + query);
    }
    const generateTaxCertificate = (data) => {
        return network.api('post', '/compliance/tds-vds/generate-tax-certificate', data);
    }
    const deleteTaxCertificate = (id, query) => {
        return network.api('delete', '/compliance/tds-vds/delete-tax-certificate/' + id + query);
    }
    const fetchTaxCertificate = (id, query) => {
        return network.api('get', '/compliance/tds-vds/tax-certificate/' + id + query);
    }
    const updateTaxCertificate = (id, data) => {
        return network.api('post', '/compliance/tds-vds/update-tax-certificate/' + id, data);
    }
    // ********************* Tds-Vds-Register-End *****************
    

    // ********************* Challan-Register-start *****************
    const fetchChallanRegister = (query) => {
        return network.api('get', '/compliance/challan-register/list' + query);
    }
    const storeChallanRegister = (data) => {
        return network.api('post', '/compliance/challan-register/create-challan', data);
    }
    const fetchSingleChallan = (query, id) => {
        return network.api('get', '/compliance/challan-register/show/' + id + query);
    }
    const updateChallanRegister = (data, id) => {
        return network.api('post', '/compliance/challan-register/update/' + id, data);
    }
    // ********************* Challan-Register-End **********************


    return {
        fetchTdsVdsRegister,
        fetchTdsVdsRegisterClientWise,
        fetchTdsVdsRegisterByBill,
        fetchVdsCertificateList,
        fetchTdsCertificateList,
        generateTaxCertificate,
        deleteTaxCertificate,
        fetchTaxCertificate,
        updateTaxCertificate,
        storeChallanRegister,
        fetchChallanRegister,
        fetchSingleChallan,
        updateChallanRegister
    }
}